(function() {
  'use strict';

  function initAvailabilityHover() {
    if (!document.body || !document.body.classList.contains('template-suffix-filtration-system-other')) {
      return;
    }

    var icons = document.querySelectorAll('.template-suffix-filtration-system-other .availability-message');
    if (!icons.length) return;

    icons.forEach(function(icon) {
      if (icon.dataset.ffHoverBound === 'true') return;
      icon.dataset.ffHoverBound = 'true';

      icon.addEventListener('mouseenter', function() {
        var delivery = getDeliveryElement(icon);
        if (delivery) delivery.style.display = 'block';
      });

      icon.addEventListener('mouseleave', function() {
        var delivery = getDeliveryElement(icon);
        if (delivery) delivery.style.display = 'none';
      });
    });
  }

  function getDeliveryElement(icon) {
    var cardSection = icon.closest('.template-suffix-filtration-system-other .card__section');
    if (!cardSection) return null;
    return cardSection.querySelector('.delivery-information');
  }

  function initPriceClassifier() {
    function removeClassificationClasses(priceList) {
      var elements = priceList.querySelectorAll('[class*="classified-"]');
      elements.forEach(function(element) {
        Array.from(element.classList).forEach(function(className) {
          if (className.indexOf('classified-') === 0) {
            element.classList.remove(className);
          }
        });
      });
    }

    function hasLineThrough(element) {
      var style = element.getAttribute('style') || '';
      return element.style.textDecoration === 'line-through' || style.indexOf('line-through') !== -1;
    }

    function classifyPrices(priceList) {
      removeClassificationClasses(priceList);

      var subscriptionPrices = priceList.querySelectorAll('.appstle_subscription_final_price');
      subscriptionPrices.forEach(function(price, index) {
        price.classList.add('classified-subscription-price');
        price.classList.add('classified-subscription-price-' + (index + 1));
      });

      var highlightedPrices = priceList.querySelectorAll('.price--highlight');
      var subscriptionOriginalIndex = 0;
      var oneTimePriceIndex = 0;

      highlightedPrices.forEach(function(price) {
        var isSubscriptionPrice = price.classList.contains('appstle_subscription_final_price');
        var crossedOut = hasLineThrough(price);

        if (!isSubscriptionPrice && crossedOut) {
          subscriptionOriginalIndex += 1;
          price.classList.add('classified-subscription-original-crossed');
          price.classList.add('classified-subscription-original-crossed-' + subscriptionOriginalIndex);
        } else if (!isSubscriptionPrice && !crossedOut) {
          oneTimePriceIndex += 1;
          price.classList.add('classified-onetime-price');
          price.classList.add('classified-onetime-price-' + oneTimePriceIndex);
        }
      });

      var comparePrices = priceList.querySelectorAll('.price--compare');
      var subscriptionCompareIndex = 0;
      var oneTimeCompareIndex = 0;

      comparePrices.forEach(function(price) {
        if (hasLineThrough(price)) {
          subscriptionCompareIndex += 1;
          price.classList.add('classified-subscription-compare-crossed');
          price.classList.add('classified-subscription-compare-crossed-' + subscriptionCompareIndex);
        } else {
          oneTimeCompareIndex += 1;
          price.classList.add('classified-onetime-compare');
          price.classList.add('classified-onetime-compare-' + oneTimeCompareIndex);
        }
      });

      var saveBadges = priceList.querySelectorAll('.appstle_subscription_save, .appstle_subscription_element');
      saveBadges.forEach(function(badge, index) {
        badge.classList.add('classified-save-badge');
        badge.classList.add('classified-save-badge-' + (index + 1));
      });
    }

    var runTimer;
    function scheduleClassification(delay) {
      clearTimeout(runTimer);
      runTimer = setTimeout(function() {
        document.querySelectorAll('.product-form__info-content .price-list').forEach(classifyPrices);
      }, typeof delay === 'number' ? delay : 120);
    }

    function observePriceContainers() {
      var containers = document.querySelectorAll('.product-form__info-content');
      if (!containers.length) return;

      var observer = new MutationObserver(function(mutations) {
        var shouldRun = mutations.some(function(mutation) {
          if (mutation.type === 'attributes') {
            return mutation.target.classList && mutation.target.classList.contains('price');
          }
          return mutation.type === 'childList';
        });

        if (shouldRun) scheduleClassification(80);
      });

      containers.forEach(function(container) {
        observer.observe(container, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'style']
        });
      });
    }

    function attachListeners() {
      scheduleClassification(300);
      document.addEventListener('change', function(event) {
        if (event.target.matches('input[name="selling_plan"]')) {
          scheduleClassification(120);
        }
      });
      document.addEventListener('click', function(event) {
        if (
          event.target.matches('input[name="selling_plan"]') ||
          event.target.closest('label[for^="appstle_selling_plan_label"]') ||
          event.target.closest('.appstle_subscription_wrapper_option')
        ) {
          scheduleClassification(120);
        }
      });
      observePriceContainers();
    }

    attachListeners();
  }

  function getStickyOffset() {
    var offset = 18;
    var selectors = [
      '#shopify-section-header',
      '.shopify-section--header',
      '.shopify-section-group-header-group',
      '.header'
    ];

    selectors.forEach(function(selector) {
      var element = document.querySelector(selector);
      if (!element) return;

      var style = window.getComputedStyle(element);
      var rect = element.getBoundingClientRect();
      var isPinned = (style.position === 'fixed' || style.position === 'sticky') && rect.top <= 10;

      if (isPinned && rect.height > 0) {
        offset = Math.max(offset, Math.min(Math.ceil(rect.height + 18), 180));
      }
    });

    return offset;
  }

  function getProductReviewTarget(trigger) {
    var productRoot = trigger.closest('[data-ff-fitting-pdp], .ff-fridge-pdp');
    var scopedTarget = productRoot ? productRoot.querySelector('[data-ff-product-reviews], [data-ff-review-carousel]') : null;

    return scopedTarget || document.querySelector('[data-ff-product-reviews], [data-ff-review-carousel], .ff-fridge-reviews');
  }

  function scrollToProductReviews(trigger, event) {
    var target = getProductReviewTarget(trigger);
    if (!target) return;

    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
    }

    function scrollToTarget(behavior) {
      var targetTop = target.getBoundingClientRect().top + window.pageYOffset - getStickyOffset();
      window.scrollTo({
        top: Math.max(0, targetTop),
        behavior: behavior
      });
    }

    scrollToTarget('smooth');
    window.setTimeout(function() {
      scrollToTarget('auto');
    }, 220);
    window.setTimeout(function() {
      scrollToTarget('auto');
    }, 620);

    if (!target.hasAttribute('tabindex')) {
      target.setAttribute('tabindex', '-1');
    }

    window.setTimeout(function() {
      try {
        target.focus({ preventScroll: true });
      } catch (error) {}
    }, 360);
  }

  function initReviewJumpLinks() {
    var triggers = document.querySelectorAll('.ff-fridge-pdp__rating, .ff-fittings-pdp .ff-fridge-pdp__rating--judgeme');
    if (!triggers.length) return;

    triggers.forEach(function(trigger) {
      if (trigger.dataset.ffReviewJumpBound === 'true') return;
      if (!getProductReviewTarget(trigger)) return;

      trigger.dataset.ffReviewJumpBound = 'true';
      trigger.dataset.ffReviewJump = 'true';
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('tabindex', '0');
      trigger.setAttribute('aria-label', trigger.getAttribute('aria-label') || 'Read customer reviews');

      trigger.addEventListener('click', function(event) {
        scrollToProductReviews(trigger, event);
      }, true);

      trigger.addEventListener('keydown', function(event) {
        if (event.key === 'Enter' || event.key === ' ') {
          scrollToProductReviews(trigger, event);
        }
      });
    });
  }

  function initReviewCarouselSwipe() {
    var carousels = document.querySelectorAll('[data-ff-review-carousel]');
    if (!carousels.length) return;

    carousels.forEach(function(carousel) {
      if (carousel.dataset.ffSwipeBound === 'true') return;
      carousel.dataset.ffSwipeBound = 'true';

      var startX = 0;
      var startY = 0;
      var lastX = 0;
      var lastY = 0;
      var tracking = false;

      carousel.addEventListener('touchstart', function(event) {
        if (!event.touches || event.touches.length !== 1) return;
        tracking = true;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        lastX = startX;
        lastY = startY;
      }, { passive: true });

      carousel.addEventListener('touchmove', function(event) {
        if (!tracking || !event.touches || event.touches.length !== 1) return;
        lastX = event.touches[0].clientX;
        lastY = event.touches[0].clientY;
      }, { passive: true });

      carousel.addEventListener('touchend', function() {
        if (!tracking) return;
        tracking = false;

        var deltaX = lastX - startX;
        var deltaY = lastY - startY;
        if (Math.abs(deltaX) < 44 || Math.abs(deltaX) < Math.abs(deltaY) * 1.35) return;

        var button = deltaX < 0
          ? carousel.querySelector('[data-ff-review-next]')
          : carousel.querySelector('[data-ff-review-prev]');

        if (button && !button.disabled) {
          button.click();
        }
      }, { passive: true });
    });
  }

  function init() {
    initAvailabilityHover();
    initPriceClassifier();
    initReviewJumpLinks();
    initReviewCarouselSwipe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
